/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PatchManagementAzureResourceDetails {
    getFixupPrototypeFunction() { return PatchManagementAzureResourceDetails.fixupPrototype; }

    static newInstance(model: Partial<PatchManagementAzureResourceDetails>): PatchManagementAzureResourceDetails {
        let obj = Object.assign(new PatchManagementAzureResourceDetails(), model);
        PatchManagementAzureResourceDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PatchManagementAzureResourceDetails>): PatchManagementAzureResourceDetails {
        if (!model) return null;
        return PatchManagementAzureResourceDetails.newInstance(<PatchManagementAzureResourceDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PatchManagementAzureResourceDetails) {
        if (!obj) return;

        models.PatchManagementAzureResourceDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PatchManagementAzureResourceDetails): boolean {
        Object.setPrototypeOf(obj, PatchManagementAzureResourceDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.patch_details) {
            models.PatchManagementAzureResourcePatchDetails.fixupPrototype(this.patch_details);
        }
        if (this.failure_details) {
            models.PatchManagementAzureResourcePatchErrorDetails.fixupPrototype(this.failure_details);
        }
    }

    /**
     * ID of the assessment activity
     */
    assessment_activity_id: string;

    /**
     * Patch details
     */
    patch_details: models.PatchManagementAzureResourcePatchDetails;

    /**
     * Patch assessment status
     */
    status: models.PatchAssessmentStatus;

    /**
     * Flag to indicate if a reboot is pending
     */
    reboot_pending: boolean;

    /**
     * Error details
     */
    failure_details: models.PatchManagementAzureResourcePatchErrorDetails;

    /**
     * Name of the user who started the patching operation
     */
    started_by: string;

    /**
     *
     */
    os_type: models.Platform;

}
